const appData = [
  { appTitle: 'Viber', appLink: 'https://www.viber.com/en/download/' },
  { appTitle: 'WeChat', appLink: 'https://www.wechat.com/en/' }
];

export const getAppData = (title?: string) =>
  appData.find(
    ({ appTitle }) => appTitle.toLowerCase() === title?.toLowerCase()
  ) ?? {};
